import './utils/polyfills';
import { captureNativeNetwork } from 'lib/nativeNetwork';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import {
  ThemeProvider,
  EasyPeasyProvider,
  I18nProvider,
  ReactQueryProvider,
  NotificationProvider,
  IconProvider,
  AuthProvider,
} from 'providers';
import { CssBaseline } from '@mui/material';
import { GlobalStyles } from 'styles/globalStyles';
import { TaskBar } from 'features/modalManager';
import { mockServer } from 'mocks/browser';

// if you run the frontend over ip, then crypto is not available, so we need to polyfill it
if (!crypto.randomUUID && crypto.getRandomValues) {
  crypto.randomUUID = (): `${string}-${string}-${string}-${string}-${string}` => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = crypto.getRandomValues(new Uint8Array(1))[0] & 15;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }) as `${string}-${string}-${string}-${string}-${string}`;
  };
}

captureNativeNetwork();
mockServer();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <I18nProvider>
      <ReactQueryProvider>
        <EasyPeasyProvider>
          <ThemeProvider>
            <IconProvider>
              <CssBaseline />
              <GlobalStyles />
              <AuthProvider>
                <TaskBar />
                <NotificationProvider />
                <RouterProvider router={router} />
              </AuthProvider>
            </IconProvider>
          </ThemeProvider>
        </EasyPeasyProvider>
      </ReactQueryProvider>
    </I18nProvider>
  </StrictMode>
);
